/**
 *
 * MeetingAssigned
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isPast } from 'utils/date-fns/index.js';
import { MEETING_STATUS_CLOSED } from '../constants.js';
import messages from './messages.js';
import MeetingButton from './MeetingButton.jsx';

function MeetingAssigned(props) {
  const { meeting } = props;
  const { set, slots } = meeting.details;
  const { registerClose, status } = set;

  const { videoMeeting } = meeting;
  if (videoMeeting && videoMeeting.link) {
    return <div className="text-muted"><FormattedMessage {...messages.videoLinkNoChange} /></div>;
  }
  const { start, locked } = slots[0];
  if (isPast(start) || isPast(registerClose)) {
    return <div className="text-muted"><FormattedMessage {...messages.registrationNoChange} /></div>;
  }
  if (locked) {
    return <FormattedMessage {...messages.assigned} />;
  }
  if (status === MEETING_STATUS_CLOSED) {
    return <FormattedMessage {...messages.registrationClosed} />;
  }
  return (
    <MeetingButton meeting={meeting} message={messages.change} />
  );
}

MeetingAssigned.propTypes = {
  meeting: PropTypes.object,
};

export default MeetingAssigned;
